import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Dropdown, Button, Grid, Input} from 'semantic-ui-react';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {pageSizes} from '../../../../common/constants/lists';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';
import InternalOrderTable from './table';

class InternalOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'clientTmp': '',
      'clientSelected': '',
      'filterOrderText': '',
      'showData': false,
    };
    this.onSearchClick = this.onSearchClick.bind(this);
    this.onCreateOrderClick = this.onCreateOrderClick.bind(this);
    this.onClearClick = this.onClearClick.bind(this);
    this.onOrderFilterChange = this.onOrderFilterChange.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.emptyOrdersData();
    this.props.changeInternalsOrdersListPage(0);
    this.props.changeInternalsOrdersListPageSize(pageSizes[0].value);
    this.props.fetchDealers('clients');
  }

  getClients() {
    return this.props.clients.map((element, index) => {
      return {'key': index, 'text': element.name, 'value': element.identification};
    });
  }

  changeClient(value) {
    this.setState({'clientTmp': value}, () => this.updateDataForClient());
  }

  updateDataForClient() {
    const {clientSelected, clientTmp} = this.state;
    if (clientSelected === clientTmp) {
      return;
    }
    this.setState({
      'clientSelected': clientTmp,
      'showData': false,
    });
    this.props.emptyOrdersData();
  }

  onOrderFilterChange(event) {
    this.setState({
      'filterOrderText': (event.target.value).toUpperCase(),
      'showData': false,
    });
  }

  onCreateOrderClick() {
    this.props.navigateTo(paths.InternalOrderCreate);
  }

  onClearClick() {
    this.setState({
      'clientTmp': '',
      'clientSelected': '',
      'filterOrderText': '',
      'showData': false,
    });
  }

  onSearchClick() {
    this.setState({'showData': true});
    const client = this.state.clientSelected;
    const order = this.state.filterOrderText;
    this.props.fetchInternalsOrdersList({client, order});
  }

  renderSearchButton() {
    const {loadingClients, loading, deleting} = this.props;
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        disabled={loadingClients || loading || deleting}
        loading={loadingClients}
        onClick={this.onSearchClick}
      >
        Buscar
      </Button>
    );
  }

  renderCreateOrder() {
    if (!(hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.Create) ||
      hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.ForOthers))) {
      return null;
    }
    
    const {loadingClients, loading, deleting} = this.props;
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        disabled={loadingClients || loading || deleting}
        loading={loadingClients}
        onClick={this.onCreateOrderClick}
      >
        Crear Pedido
      </Button>
    );
  }

  renderClearButton() {
    const {loadingClients, loading, deleting} = this.props;
    return (
      <Button
        type='button'
        secondary
        className='toyota-primary'
        disabled={loadingClients || loading || deleting}
        loading={loadingClients}
        onClick={this.onClearClick}
      >
        Limpiar
      </Button>
    );
  }

  render() {
    const {clientTmp, filterOrderText, showData} = this.state;
    const {loadingClients} = this.props;

    return (
      <div className='internal-orders-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>
                Pedidos Internos
              </h2>
              <div className='title-bar-actions'>
                {this.renderCreateOrder()}
              </div>
            </div>
            
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={1}>
                    <h4>Cliente</h4>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Dropdown selection
                      options={this.getClients()}
                      search
                      value={clientTmp}
                      disabled={loadingClients}
                      loading={loadingClients}
                      onChange={(e, {value}) => this.changeClient(value)}
                      placeholder='Clientes'
                      noResultsMessage='Cliente no encontrado'
                    />
                  </Grid.Column>
                  <Grid.Column width={1} className='order-label'>
                    <h4># Pedido</h4>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input
                      placeholder='# Pedido'
                      value={filterOrderText}
                      onChange={this.onOrderFilterChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={5} textAlign='right'>
                    {this.renderClearButton()}
                    {this.renderSearchButton()}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>

          </div>
        </Card>
        <InternalOrderTable showData={showData} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingClients': state.dealer.loading,
    'clients': state.dealer.list,
    'loading': state.internalOrder.loading,
    'internalsOrdersList': state.internalOrder.internalsOrdersListByPage,
    'deleting': state.internalOrder.deleting,
    'pageSize': state.internalOrder.pageSize,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  fetchDealers,
  emptyOrdersData,
  changeInternalsOrdersListPage,
  changeInternalsOrdersListPageSize,
  fetchInternalsOrdersList,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchDealers,
  emptyOrdersData,
  changeInternalsOrdersListPage,
  changeInternalsOrdersListPageSize,
  fetchInternalsOrdersList,
})(InternalOrder);
